export function numberWithCommas(x: number) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function roundedSalary(x: number) {
  const rounded = Math.round(x / 1000) * 1000;
  return numberWithCommas(rounded);
}
